export const CONFIG = window.TENNIS_CALENDAR_CONFIG;
export const API = process.env.VUE_APP_API_URL;
export const BACKEND = process.env.VUE_APP_BACKEND_URL;
export const SECRET = process.env.VUE_APP_SECRET;